import { runtimeConfig } from './runtimeConfig';

export type ClientBuildConfig = {
  name: string;
  environment: string;
  clientId: string;
  authority: string;
  scopes: string[];
  apiBaseUrl: string;
};

const defaultClientId = '979edd7c-efd2-466f-84ed-a91d25fe8150';
const configuredClientId = import.meta.env.VITE_ENTRA_CLIENT_ID || defaultClientId;

const clientBuilds: Record<string, ClientBuildConfig> = {
  default: {
    name: 'default',
    environment: import.meta.env.MODE,
    clientId: configuredClientId,
    authority:
      import.meta.env.VITE_ENTRA_AUTHORITY || 'https://login.microsoftonline.com/organizations',
    scopes: [import.meta.env.VITE_ENTRA_SCOPE || `api://${configuredClientId}/access_as_user`],
    apiBaseUrl: runtimeConfig.apiBaseUrl,
  },
};

function validateConfig(config: ClientBuildConfig): ClientBuildConfig {
  if (!config.clientId || !config.authority || config.scopes.length === 0) {
    throw new Error(`Invalid authentication configuration for '${config.name}'.`);
  }

  if (config.apiBaseUrl && !URL.canParse(config.apiBaseUrl)) {
    throw new Error(`Invalid API base URL for '${config.name}'.`);
  }

  return config;
}

const selectedBuild = import.meta.env.VITE_CLIENT_BUILD || 'default';
const selectedConfig = clientBuilds[selectedBuild];

if (!selectedConfig) {
  throw new Error(`Unknown client build '${selectedBuild}'.`);
}

export const buildConfig = validateConfig(selectedConfig);
